import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { WebinarLink } from './WebinarLink';
export const Benefits = ({
  openModal
}) => {
  // Replace 'webinar' with WebinarLink component in text
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-21">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-22">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-23">
        Het moment van transformatie
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-24">
        Lisa herkent dit moment: "Het kwartje viel toen Amee uitlegde hoe honden
        vanuit hun natuur gewend zijn met elkaar om te gaan. Ik begreep dat
        Benny helemaal niet koppig was - hij begreep mij gewoon niet, net zoals
        ik hem niet begreep. We hadden gewoon langs elkaar heen gecommuniceerd."
      </p>
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-100" data-id="element-25">
        <h3 className="text-lg font-bold text-blue-800 mb-4" data-id="element-26">
          Wat deelnemers ontdekken:
        </h3>
        <ul className="space-y-4 mb-6" data-id="element-27">
          <li className="flex items-start" data-id="element-28">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-29" />
            <span data-id="element-30">
              <strong data-id="element-31">Dat onrustige gedrag?</strong> Vaak mentale vermoeidheid,
              niet fysieke energie.
            </span>
          </li>
          <li className="flex items-start" data-id="element-32">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-33" />
            <span data-id="element-34">
              <strong data-id="element-35">Die korte blikken naar de deur?</strong> Je hond probeert
              je mee te nemen naar iets interessants.
            </span>
          </li>
          <li className="flex items-start" data-id="element-36">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-37" />
            <span data-id="element-38">
              <strong data-id="element-39">Dat wegkijken wanneer je hem roept?</strong> Respect, geen
              negeren.
            </span>
          </li>
        </ul>
        <p className="italic" data-id="element-40">
          In 90 minuten leer je eindelijk wat je hond al die tijd probeerde te
          zeggen. Het eerstvolgende gratis {replaceWebinarWithLink('webinar')}{' '}
          is vandaag en morgen.
        </p>
      </div>
    </section>;
};